import { ShowCaseContent } from './ShowCaseContent';

export default ShowCaseContent;
